function typeName(name, iteration) {
    // Prevent our code executing if there are no letters left
    if (iteration === name.length)
        return;
    
    setTimeout(function() {
        // Set the name to the current text + the next character
        // whilst incrementing the iteration variable
        $('input#search-shop').attr('placeholder',  $('input#search-shop').attr('placeholder') + name[iteration++]);
        
        // Re-trigger our function
        typeName(name, iteration);
    }, 100);
}

function openPopup(){
  console.log('...openPopup');
  $('#openpopup').click();
}

var interval_id; 
document.addEventListener("visibilitychange", () => {
   if (document.hidden) {
      // tab is changed
      initSearchAutocomplete(false);
   } else {
      // tab is active
      initSearchAutocomplete(true);
   }
});

function initSearchAutocomplete(active=true){
  if(active){
    const listKeywords = ["Auto Repair Service", "AC / Heat Repair", "Brake Repair", "Diagnostics", "Engine & Tune Ups", "NH State Inspection", "Oil Changes & Lube Service", "Steering & Suspension", "Vehicle Maintenance", "Truck Beds", "Financing", "Specials"];
    const repeatNumber = listKeywords.length - 1;
    var i = 0;
     interval_id = setInterval(function() {
      //console.log(listKeywords[i]);
      $('input#search-shop').attr("placeholder","");
      typeName(listKeywords[i], 0);
      i+=1;
      if(i > repeatNumber){
        i = 0;
      }
    }, 3500);
  }else{
    clearInterval(interval_id);
  }
}

$(document).ready(function ($) {
  
  initSearchAutocomplete(true);
  
  const hrefFromPopup =  $('.popupbtn').parent().parent().attr('href');
  console.log(hrefFromPopup);
   $('.popupbtn').attr('href',hrefFromPopup);
  
 
  $('a[href="#salescaptain-signup-widget"]').magnificPopup({
    type:'inline',
    midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });

  /*

  $("a").each(function() {
    var href = $(this).attr('href');
    var existClass = $(this).attr('class');
    if(href == '#salescaptain-signup-widget' && existClass != 'open-popup'){
      console.log(href);
      $(this).attr('onclick', 'openPopup()');
    }
  });
  */
   
  
});


var windowWidth = $(window).width();
if (windowWidth >= 1200) {
      $(".desk-megaLink").click(function(){
        var href = $(this).attr('href');
        window.location.href = href;
        console.log('desktop = '+href);
      });
}else{
}


 $(window).resize(function() {
    var win = $(this); //this = window
    if (win.width() >= 1200) { 
      $(".desk-megaLink").click(function(){
        var href = $(this).attr('href');
        window.location.href = href;
        console.log('desktop = '+href);
      });
      
    }else{
      console.log('moblie');
    }
  
});

window.addEventListener("DOMContentLoaded", e =>
{
  document.querySelectorAll('a[href]').forEach(a =>
  {
    if (location.hostname == new URL(a.href).hostname)
      return;

    a.target = "_blank";
    a.rel = "noreferrer nofollow noopener";
  });
});
